export enum MESSAGE_STATUSES {
  SEND = "send",
  RECEIVED = "received",
  READ = "read",
  ERROR = "error",
}
